module.exports = __webpack_public_path__ + "static/media/IMG_20181113_004408.63ca4cf7.jpg";